import React, { useState } from 'react';
import { MenuIcon, LogoutIcon } from '../icons';
import Sidebar from './Sidebar';

const Layout = ({ children, currentUser, onNav, onLogout, currentPage, adminUnreadCount = 0 }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F6F8FB]">
      <div className="pointer-events-none fixed left-4 right-4 top-[calc(0.75rem+env(safe-area-inset-top))] z-40 flex items-center justify-between lg:hidden">
        <button
          type="button"
          onClick={() => setIsMobileNavOpen(true)}
          className="pointer-events-auto flex h-10 w-10 items-center justify-center rounded-xl bg-[#0B1728] text-white/85 shadow-[0_10px_28px_rgba(15,23,42,0.18)] ring-1 ring-white/10"
          aria-label="Abrir navegación"
        >
          <MenuIcon />
        </button>
        {currentUser ? (
          <button
            type="button"
            onClick={onLogout}
            className="pointer-events-auto flex h-10 w-10 items-center justify-center rounded-xl bg-[#0B1728] text-white/85 shadow-[0_10px_28px_rgba(15,23,42,0.18)] ring-1 ring-white/10"
            aria-label={currentUser.role === 'public' ? 'Volver al acceso' : 'Salir'}
            title={currentUser.role === 'public' ? 'Volver al acceso' : 'Salir'}
          >
            <LogoutIcon />
          </button>
        ) : (
          <div className="h-10 w-10" aria-hidden="true" />
        )}
      </div>

      {isMobileNavOpen && (
        <button
          type="button"
          aria-label="Cerrar navegación"
          className="fixed inset-0 z-40 bg-slate-950/55 lg:hidden"
          onClick={() => setIsMobileNavOpen(false)}
        />
      )}

      <Sidebar
        currentUser={currentUser}
        onNav={onNav}
        onLogout={onLogout}
        currentPage={currentPage}
        isOpen={isMobileNavOpen}
        onClose={() => setIsMobileNavOpen(false)}
        adminUnreadCount={adminUnreadCount}
      />
      <main className="min-h-screen w-full min-w-0 bg-[#F6F8FB] pt-[calc(3.75rem+env(safe-area-inset-top))] lg:pl-64 lg:pt-0">
        {children}
      </main>
    </div>
  );
};

export default Layout;
